import ReportsSerializer from './base';

export default class RubricState extends ReportsSerializer {}
